import axiosInstance from "@/api/axiosInstance";

export class IncomingBillService {
  public async getAll(): Promise<any> {
    try {
      const response = await axiosInstance.get("/api/v1/admin/bills");
      return response.data;
    } catch (e) {
      console.log("IncomingBillService getAll threw error", e);
    }
  }

  /** Errors propagate: the view classifies them and renders the failure in place. */
  public async get(id: number): Promise<any> {
    const response = await axiosInstance.get(`/api/v1/admin/bills/${id}`);
    return response.data;
  }

  public async getByBookingItem(bookingItemId: number): Promise<any> {
    try {
      const response = await axiosInstance.get(
        `/api/v1/admin/bills/booking-item/${bookingItemId}`
      );
      return response.data;
    } catch (e) {
      console.log("IncomingBillService getByBookingItem threw error", e);
    }
  }

  public async create(body: {
    identifier: string;
    status: string;
    type: string;
    amount: number;
    bookingItemIds: number[];
  }): Promise<any> {
    try {
      const response = await axiosInstance.post("/api/v1/admin/bills", body);
      return response.data;
    } catch (e) {
      console.log("IncomingBillService create threw error", e);
      // Rethrown so the caller can surface the rejection (e.g. a missing amount).
      throw e;
    }
  }

  /** Partial update: only the keys present in `body` are applied, so one save is one request. */
  public async patch(
    id: number,
    body: { status?: string; amount?: number; paidAt?: number | null }
  ): Promise<any> {
    try {
      const response = await axiosInstance.patch(
        `/api/v1/admin/bills/${id}`,
        body
      );
      return response.data;
    } catch (e) {
      console.log("IncomingBillService patch threw error", e);
      // Rethrown so the caller can surface the rejection (e.g. a missing amount).
      throw e;
    }
  }

  public async updateBookingItems(
    id: number,
    bookingItemIds: number[]
  ): Promise<any> {
    try {
      const response = await axiosInstance.put(
        `/api/v1/admin/bills/${id}/booking-items`,
        bookingItemIds
      );
      return response.data;
    } catch (e) {
      console.log("IncomingBillService updateBookingItems threw error", e);
    }
  }

  public async getBookingItems(
    params: {
      accommodation?: string;
      startDate?: string;
      endDate?: string;
    } = {}
  ): Promise<any> {
    try {
      const response = await axiosInstance.get("/api/v1/admin/booking-items", {
        params,
      });
      return response.data;
    } catch (e) {
      console.log("IncomingBillService getBookingItems threw error", e);
    }
  }
}
